import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    footerContainer: 'p-4 space-y-2',
    footerShippingTaxHint: 'body-5 mt-1 c-grey-20',
    footerTotalAmount: 'subtitle-2',
    footerTotalLabel: 'subtitle-2'
  }
} satisfies RecursivePartial<DialogConfig['miniCart']>
